import Style from "../../../../css/style.module.css";
import AttendStateFunc from "@/pcomponents/common/content/edu/attend/func/state_func";

const CardBoxAttendArea = (props:any) => {
  let myProps:any={
    user_info:{},
    attend_in_info:null,
    attend_out_info:null,
    attend_color:"",
    deleteAttend:(inData:any)=>{},
    openAttendPopup:(inData:any)=>{},
    ...props
  };

  const getAttendInCellRenderBtns=()=>{
    let attend_in_state_arr=[
      {"value":"attend","text":"등원","class_name":Style.attend_in_btn},
      {"value":"late","text":"지각","class_name":Style.attend_late_btn},
      {"value":"absent","text":"결석","class_name":Style.attend_no_btn},
    ];
    let attend_in_btns=attend_in_state_arr.map((item:any,idx:number)=>{
      let btn_class=Style.attend_btn;
      let is_checked_btn=false;
      let attend_info:any=myProps.attend_in_info;
      if(attend_info!=null){
        if(attend_info["a_sort_detail"]==item["value"]){
          btn_class+=" "+item.class_name;
          is_checked_btn=true;
        }
      }
      if(idx!=0){
        btn_class+=" ml-2";
      }
      return (
        <button key={idx}
         className={btn_class}
         onClick={()=>{
          if(is_checked_btn){
            if(attend_info!=null){
              myProps.deleteAttend([attend_info],"등원 취소 하시겠습니까?");
            }
          }else{
            myProps.openAttendPopup([myProps.user_info],"in",item.value);
          }
        }}
         >{item.text}</button>
      );
    });
    return attend_in_btns;
  };

  let is_checked_btn=false;
  let attend_out_info:any=myProps.attend_out_info;
  let attend_out_class_name=Style.attend_btn;
  if(attend_out_info!=null){
    if(attend_out_info["a_sort"]=="out"){
      is_checked_btn=true;
      attend_out_class_name+=" "+Style.attend_out_btn;
    }
  }
  let attend_out_btn:any="";
  if(myProps.attend_in_info!=null){
    attend_out_btn=(
      <button className={attend_out_class_name+" ml-2"} 
        onClick={()=>{
          if(is_checked_btn){
            if(attend_out_info!=null){
              myProps.deleteAttend([attend_out_info],"하원 취소 하시겠습니까?");
            }
          }else{
            myProps.openAttendPopup([myProps.user_info],"out","out");
          }
        }} >하원
      </button>
    );
  }

  let attend_state_str="미등원";
  let attend_time="00:00";
  if(myProps.attend_in_info!=null){
    attend_time=myProps.attend_in_info["a_time"].substring(0,5);
    let a_sort_detail=myProps.attend_in_info["a_sort_detail"];

    if(myProps.attend_out_info!=null){
      attend_time=myProps.attend_out_info["a_time"].substring(0,5);
      a_sort_detail=myProps.attend_out_info["a_sort_detail"];
    }

    if(AttendStateFunc.select_arr.a_sort_detail){
      for(let i=0;i<AttendStateFunc.select_arr.a_sort_detail.length;i++){
        let item=AttendStateFunc.select_arr.a_sort_detail[i];
        if(item.value==a_sort_detail){
          attend_state_str=item.text;
        }
      }
    }

  }
  if(attend_state_str=="등원"){
    attend_state_str="등원완료";
  }

  return (
    <>
      <div className={Style.card_box_attend_state}>
        <p className={Style.card_box_attend_state_title} style={{color:myProps.attend_color}}>
          {attend_state_str}
        </p>
        <p className={Style.card_box_attend_state_time} >{attend_time}</p>
      </div>
      <div className={Style.card_box_attend_btn_wrap} >
        <p className={Style.card_box_attend_btn_title}>상태변경</p>
        <div className={Style.card_box_attend_btn_box}>
          {getAttendInCellRenderBtns()}
          {attend_out_btn}
        </div>
      </div>
    </>
  );
};

export default CardBoxAttendArea;